import { dayjs } from '@keepeek/commons';
import isArray from 'lodash/isArray';

/**
 *
 * @param visualAlertText visualAlertText in current locale configured
 * @param fieldValue the value of the field
 * @param displayFieldValue if true the field value will be added next to the text
 * @returns the text value to display in the Tag (for date field, the value will be formatted)
 */
function computeTextToDisplay(visualAlertText, fieldValue, displayFieldValue, element) {
    var _a, _b;
    if (displayFieldValue && fieldValue) {
        // if the field value is a date, format it
        if (Date.parse((fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.toString()) || "")) {
            var fieldValueAsDate = new Date((fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.toString()) || "");
            var fieldValueAsDateFormatted = dayjs(fieldValueAsDate).format("LL");
            visualAlertText += " (".concat(fieldValueAsDateFormatted, ")");
        }
        else {
            visualAlertText += " (".concat(fieldValue, ")");
        }
    }
    if (visualAlertText.includes("{{") && visualAlertText.includes("}}")) {
        var variable_1 = visualAlertText.split("{{")[1].split("}}")[0];
        var content = (_b = (_a = element === null || element === void 0 ? void 0 : element.fields) === null || _a === void 0 ? void 0 : _a.find(function (f) { return f.id === variable_1; })) === null || _b === void 0 ? void 0 : _b.value;
        content = isArray(content) ? content[0] : content || "";
        if (content.split("-").length >= 2 && typeof Number(content.charAt(0)) === "number") {
            content = dayjs(content).format("DD/MM/YYYY");
        }
        return visualAlertText.replace("{{".concat(variable_1, "}}"), content);
    }
    return visualAlertText;
}

export { computeTextToDisplay };
//# sourceMappingURL=computeTextToDisplay.js.map
